module.exports = "/_next/static/images/icon_chat-60efbf5929a0335f6c1ac2fbf8bb288b.svg";